/* Creator code calls (src/server/modules/creators/contracts.ts). */
import { api } from "./api";

export interface CreatorTier { key: string; name: string; rateBps: number }
/** POST /api/creators and GET /api/creators/me */
export interface MyCreator {
  code: string;
  status: string;
  tier: CreatorTier;
  nextTier: (CreatorTier & { atReferrals: number; referralsToGo: number }) | null;
  referrals: number;
  boxesOpened: number;
  earnedCents: number;
  createdAt: string;
}

/** claim her own code from a name or handle; needs a signed-in session */
export const claimCreatorCode = (handle: string) =>
  api<MyCreator>("POST", "/api/creators", { body: { handle } });

/** her code and live stats; 404 NOT_A_CREATOR when she has no code */
export const getMyCreator = () => api<MyCreator>("GET", "/api/creators/me");

/* The server's rule (creators/config.ts), for the live preview only; the
   server derives and stores the real code. "@mia" -> "MIA5". */
export const HANDLE_MIN_LETTERS = 3;
const HANDLE_MAX_LETTERS = 10;
const SUFFIX = "5";
export const handleLetters = (raw: string) => raw.trim().toUpperCase().replace(/[^A-Z0-9]/g, "");
export function previewCode(handle: string): string | null {
  const letters = handleLetters(handle).slice(0, HANDLE_MAX_LETTERS);
  return letters.length >= HANDLE_MIN_LETTERS ? letters + SUFFIX : null;
}
